import {
  DailyWorkloadCrosstableProfessional,
} from 'domain/models';
import { Table } from 'reactstrap';

interface IProps {
  dates: string[];
  professionals: DailyWorkloadCrosstableProfessional[];
}

const formatMinutes = (minutes: number): string => {
  if (!minutes) return '—';
  const h = Math.floor(minutes / 60).toString().padStart(2, '0');
  const m = (minutes % 60).toString().padStart(2, '0');
  return `${h}:${m}`;
};

const formatDateHeader = (date: string): string => {
  const [, month, day] = date.split('-');
  const monthNames = [
    'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
    'jul', 'ago', 'set', 'out', 'nov', 'dez',
  ];
  return `${day}/${monthNames[parseInt(month, 10) - 1]}.`;
};

export const DailyWorkloadTable = ({ dates, professionals }: IProps) => {
  return (
    <Table responsive hover className="align-middle table-borderless mb-0">
      <thead>
        <tr>
          <th style={{ minWidth: 200 }}>Profissional</th>
          {dates.map((date) => (
            <th key={date} className="text-center" style={{ minWidth: 70 }}>
              {formatDateHeader(date)}
            </th>
          ))}
          <th className="text-center" style={{ minWidth: 80 }}>
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        {professionals.map((professional) => {
          const entryMap = new Map(
            professional.entries.map((e) => [e.date, e]),
          );

          return (
            <tr key={professional.professionalHashId}>
              <td>
                <div className="d-flex align-items-center gap-2">
                  {professional.professionalPhoto ? (
                    <img
                      src={professional.professionalPhoto}
                      alt={professional.professionalName}
                      width={32}
                      height={32}
                      className="rounded-circle object-fit-cover"
                    />
                  ) : (
                    <div
                      className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                      style={{ width: 32, height: 32 }}
                    >
                      <i className="ri-user-3-line text-muted" />
                    </div>
                  )}
                  <div>
                    <div>{professional.professionalName}</div>
                    {professional.professionalRole != null && (
                      <small className="text-muted">
                        {professional.professionalRole}
                      </small>
                    )}
                  </div>
                </div>
              </td>
              {dates.map((date) => {
                const entry = entryMap.get(date);
                return (
                  <td key={date} className="text-center">
                    {entry && entry.totalMinutes > 0
                      ? formatMinutes(entry.totalMinutes)
                      : '—'}
                  </td>
                );
              })}
              <td className="text-center fw-semibold">
                {formatMinutes(professional.totalMinutes)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
